module.exports = __webpack_public_path__ + "media/images/emblems/Bourg-Saint-Pierre-blazono-c33f8f4ddcec00872107e27a53a7281d.png";